import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Link, Switch } from "react-router-dom";
import NavbarTop from "../components/navbar/NavbarTop";
import NavbarVertical from "../components/navbar/NavbarVertical";
import Footer from "../components/common/Footer";
import loadable from "@loadable/component";
import AppContext from "../context/Context";
import { getPageName } from "../helpers/utils";
import UserPrivateRoute from "../hoc/UserPrivateRoute";
import ApplicationsDetails from "../components/user/ApplicationsDetails";
import TwoFactorImportant from "./TwoFactorModel";
import { toast } from "react-toastify";
import { Alert, Row, Card } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faInfoCircle,
  faLightbulb,
  faPencil,
} from "@fortawesome/free-solid-svg-icons";
import apiCall from "../services/apiCall";
import CardExpireModal from "./CardExpireModal";
import ButtonIcon from "../components/common/ButtonIcon";
import ModalCustom from "../components/common/ModalCustom";
import AccountRecoveryModel from "../components/admin-user-common/AccountRecovery/AccountRecoveryModel";

const UserDashboardRoutes = loadable(() => import("./UserDashboardRoutes"));
const UserDashboardLayout = ({ location }) => {
  const {
    isFluid,
    isVertical,
    navbarStyle,
    remember,
    rememberEmail,
    rememberPass,
    loginUserDetails,
  } = useContext(AppContext);

  const isKanban = getPageName("kanban");
  useEffect(() => {
    UserDashboardRoutes.preload();
    if (remember && rememberEmail) {
      localStorage.setItem(
        "remember",
        JSON.stringify({
          email: rememberEmail,
          password: rememberPass,
        })
      );
    }
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const [isSpuAlert, setIsSpuAlert] = useState(true);
  const [applicationList, setApplicationList] = useState([]);
  const [spuCriticalData, setSpuCriticalData] = useState([]);
  const [recoveryStatus, setRecoveryStatus] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [showRecoveryModel, setShowRecoveryModel] = useState(false);

  
  const onDismiss = () => {
    const data = { link: false, isSpuAlert: false, isClicked: false };
    localStorage.setItem("isSpuAlert", JSON.stringify(data));
    setIsSpuAlert(false);
  };

  const onDismissAccountRecovery = () => {
    localStorage.removeItem("accountRecoveryModel");
    setRecoveryStatus(false);
    setShowPaymentModal(false);
  };

  const fetchApplicationData = () => {
    const body = {
      devid: loginUserDetails.parent_dev_id,
    };
    apiCall
      .servertrip(
        "POST",
        "all_partner_all_apps",
        loginUserDetails,
        undefined,
        body
      )
      .then(
        (res) => {
          setApplicationList(res.data.items);
        },
        (error) => {}
      );
  };

  const fetchSPUData = () => {
    const body = {
      dev_ids: loginUserDetails?.parent_dev_id,
      app_ids:
        applicationList.length > 0
          ? applicationList.map((item) => item.app_id).join(",")
          : "",
    };

    apiCall
      .servertrip(
        "POST",
        "get_installed_spus",
        loginUserDetails,
        undefined,
        body
      )
      .then(
        (res) => {
          const data = res.data?.items;

          if (data.length > 0) {
            const criticalData = data.filter((item) => {
              let errorCount = Object.keys(item["error"]);

              if (errorCount.length >= 4) {
                return item;
              }
            });

            setSpuCriticalData(criticalData);
          } else {
            setSpuCriticalData([]);
          }
        },
        (error) => {}
      );
  };

  useEffect(() => {
    if (loginUserDetails?.is_partner == "1") {
      const isSpuAlertLocal = localStorage.getItem("isSpuAlert")
        ? JSON.parse(localStorage.getItem("isSpuAlert")).isSpuAlert
        : true;
      setIsSpuAlert(isSpuAlertLocal);
      if (isSpuAlert) {
        fetchApplicationData();
      }
    }
  }, []);

  useEffect(() => {
    if (
      applicationList.length > 0 &&
      loginUserDetails?.is_partner == "1" &&
      isSpuAlert
    ) {
      fetchSPUData();
      const alreadyShown = sessionStorage.getItem("cardExpireShown") === "true";
      const is2FAModalOpen = loginUserDetails?.is_2fa_enabled === "no";
      if (!alreadyShown && !is2FAModalOpen) {
        setShowPaymentModal(true);
      }
    }
  }, [applicationList]);

  return (
    <div className={isFluid || isKanban ? "container-fluid" : "container"}>
      {isVertical && (
        <NavbarVertical isKanban={isKanban} navbarStyle={navbarStyle} />
      )}
      <div className="content">
        {!window.location.href.includes("Chatbox") ? <NavbarTop /> : null}
        {!window.location.href.includes("Chatbox") ? (
          <>
            {loginUserDetails.is_partner == "1" && spuCriticalData.length > 0 && (
              <>
                <Alert
                  color="warning"
                  isOpen={isSpuAlert}
                  toggle={onDismiss}
                  className="mx-2"
                >
                  <div className="spu-alert-container d-flex align-items-center justify-content-between">
                    <div className="spu-alert-icon-title d-flex align-items-center">
                      <div className="spu-alert-icon mr-2">
                        <FontAwesomeIcon icon={faInfoCircle} />
                      </div>
                      <div className="spu-alert-title">
                        <b className="mr-2">{spuCriticalData.length}</b>
                        <span>
                          SPU(s) do not meet minimum system requirements.
                        </span>
                      </div>
                    </div>
                    <div className="spu-alert-visit">
                      <Link
                        to={`${process.env.PUBLIC_URL}/user/spudashboard`}
                        onClick={() => {
                          const data = {
                            link: true,
                            isClicked: true,
                            isSpuAlert: true,
                          };
                          localStorage.setItem(
                            "isSpuAlert",
                            JSON.stringify(data)
                          );

                          setTimeout(() => {
                            localStorage.setItem(
                              "isSpuAlert",
                              JSON.stringify({ ...data, isClicked: false })
                            );
                          }, 1000);
                        }}
                      >
                        View details
                      </Link>
                    </div>
                  </div>
                </Alert>
              </>
            )}
          <Card className="mb-3 w-100">
            <Row className="pl-4 pt-2 pb-2">
              <h5 className="fs-0 fw-semi-bold mb-2 text-primary-emphasis">
                <a
                  href="https://www.reddit.com/r/sikkaaibuilder/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="animate-charcter"
                >
                  Let’s talk about our One-Click Healthcare App Builder on Reddit!
                </a>
              </h5>
            </Row>
          </Card>
          </>
        ) : null}
        <Switch>
          <UserPrivateRoute
            path={`${process.env.PUBLIC_URL}/user/applications`}
            exact
            component={ApplicationsDetails}
          />
          <UserDashboardRoutes />
        </Switch>
        {!window.location.href.includes("Chatbox")
          ? !isKanban && <Footer />
          : null}
      </div>

      <TwoFactorImportant />
      <AccountRecoveryModel/>
      {showPaymentModal && <CardExpireModal />}
    </div>
  );
};

UserDashboardLayout.propTypes = { location: PropTypes.object.isRequired };

export default UserDashboardLayout;
